import Typography from "antd/lib/typography";
import { useTranslation } from "react-i18next";

export const SkipLinks = () => {
    const [t] = useTranslation();

    return (
        <Typography.Link
            href="#main-content"
            className="absolute top-ant left-ant-xs z-overlay translate-x-[-105%] rounded-ant-lg bg-white! px-4! py-2! no-underline transition-transform duration-300 focus:translate-x-0 focus:outline-[3px] motion-reduce:transition-none"
        >
            <Typography.Text className="text-ant-lg font-ant-strong">
                {t("layout.skip-links.go-to-main-content")}
            </Typography.Text>
        </Typography.Link>
    );
};
